import { render, staticRenderFns } from "./GoogleMegaboxBanner.vue?vue&type=template&id=c89e5e7a&"
import script from "./GoogleMegaboxBanner.vue?vue&type=script&lang=js&"
export * from "./GoogleMegaboxBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports